const placeholderRegex = /(%?\{{1,2})(.+?)(\}{1,2})/g;

const parseMessage = (message: string, values: Record<string, any>): string =>
  message.replace(placeholderRegex, (fullMatch, _, id) => values[id] || fullMatch);

export default parseMessage;
